import { formatReels, formatUserSessions, formatUserUploadedFeed, tabList } from "_components/pages/userProfile/utils";
import { getUserSessions }                                                  from "_services/api/broadcast";
import { getReels, getUserUploadedFeed }                                    from "_services/api/feed";

export const processUploadedImageFile = imageFile =>
	new Promise ( ( resolve, reject ) => {
		const { size, type, preview } = imageFile;

		if ( type ) {
			const splittedType = type.split ( "/" );

			if ( splittedType[0] === "image" ) {
				const imageObj = {
					size,
					preview,
					type: splittedType[1]
				};
				let reader     = new FileReader ();

				reader.onload = function ( e ) {
					let previewImage = new Image ();

					previewImage.src = reader.result;

					previewImage.onload = function () {
						resolve ( {
							...imageObj,
							height  : previewImage.height,
							width   : previewImage.width,
							preview : e.target.result
						} );
					};
				};

				reader.readAsDataURL ( imageFile );
			} else {
				reject ( { errorTitle: "Error: File must be an image." } );
			}
		} else {
			reject ( { errorTitle: "Error: File uploaded is of unknown type." } );
		}
	} );

export const fetchData = async function ( props ) {

	const { id, tab, pageNo } = props;

	if ( !id && !tab ) return;

	let feedApiData = [];
	let params      = {
		sportsFanId : id,
		pageNo      : pageNo,
		pageSize    : 10
	};

	switch ( tab ) {
		case tabList[0].value:
			feedApiData = await getUserSessions.bind ( this ) ( params );
			feedApiData = formatUserSessions ( feedApiData );
			break;

		case tabList[1].value:
			params["type"] = "video";
			feedApiData    = await getUserUploadedFeed.bind ( this ) ( params );
			feedApiData    = formatUserUploadedFeed ( feedApiData );
			break;

		case tabList[2].value:
			feedApiData = await getReels.bind ( this ) ( params );
			feedApiData =  formatReels ( feedApiData );
			break;

		case tabList[3].value:
			params["type"] = "image";
			feedApiData    = await getUserUploadedFeed.bind ( this ) ( params );
			break;

		default:
			break;
	}

	return feedApiData;
};
